import { Component, OnInit } from '@angular/core';
import { element } from '@angular/core/src/render3';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  subscriptionForm: FormGroup;
  showNavigationArrows = false;
  showNavigationIndicators = false;
  images = [1, 2, 3, 4, 5, 6, 7].map(ele => `/assets/covers/cover${ele}.jpg`);

  constructor(config: NgbCarouselConfig, private formBuilder: FormBuilder) {
    // customize default values of carousels used by this component tree
    config.showNavigationArrows = true;
    config.showNavigationIndicators = true;
  }
  ngOnInit() {
    this.subscriptionForm = this.formBuilder.group({
      fromAddress: ['', Validators.required],
      toAddress: ['', Validators.required],
      email: ['', Validators.required]
    });
  }
}
